import { Component, type ReactElement, type ReactNode } from 'react';
import { AdminCardError } from '@/components/atoms/admin-card-error';

export type AdminCardErrorBoundaryProps = {
  cardLabel: string;
  children: ReactNode;
};

type State = { hasError: boolean };

export class AdminCardErrorBoundary extends Component<AdminCardErrorBoundaryProps, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  private readonly handleRetry = (): void => {
    this.setState({ hasError: false });
  };

  override render(): ReactNode {
    if (this.state.hasError) {
      return this.renderFallback();
    }
    return this.props.children;
  }

  private renderFallback(): ReactElement {
    return (
      <AdminCardError
        label={this.props.cardLabel}
        action={
          <button
            type="button"
            onClick={this.handleRetry}
            className="text-[12px] font-medium text-[var(--err)] underline underline-offset-2"
          >
            Retry
          </button>
        }
      />
    );
  }
}
